export default __webpack_public_path__ + "static/fin-int-invest-b710b10195fae23366936bfdcf1fd61e.png";